import {COLORS, SPACING, Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const AvailabilityInfo: React.FC<{info: string}> = ({info}) => {
  return (
    <Wrapper size="px10" color="Text.Grey" textAlignment="center">
      {info}
    </Wrapper>
  );
};

const Wrapper = styled(Text)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  line-height: 1.6;
  background-color: ${COLORS['Fill.Grey.Primary']};
  border-radius: 4px;
  padding: ${SPACING['Y.Sm']} ${SPACING['X.Md']};
  margin-left: 6px;

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: -10px;
    transform: translateY(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: transparent ${COLORS['Fill.Grey.Primary']} transparent
      transparent;
  }
`;
